import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CourseraDashboardStats } from './coursera-dashboard-stats.model';
import { config } from 'src/app/config/api.config';

@Injectable({
  providedIn: 'root',
})
export class CourseraDashboardService {
  constructor(private httpClient: HttpClient) {}

  getDashboard(cohorte: string): Observable<CourseraDashboardStats> {
    return this.httpClient.get<CourseraDashboardStats>(
      `${config.apiBaseUrl}/coursera/stats/dashboard/` + cohorte,
    );
  }
}
